module.exports = __webpack_public_path__ + "img/PE.23f4fbf5.svg";